import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';

export class ErpObjectConversionRequestOptions<T extends EMode = EMode.entity> {
  /** Alias: refreshHeadAndClosingText */
  refreshHeadAndClosingText?: any;
  /** Alias: createHistoryPosition */
  createHistoryPosition?: any;

  __typename?: string;
}

const fields: FieldDefinitions<ErpObjectConversionRequestOptions> = {
  refreshHeadAndClosingText: {
    alias: 'refreshHeadAndClosingText',
  },
  createHistoryPosition: {
    alias: 'createHistoryPosition',
  },
  __typename: {
    alias: '__typename',
  },
};

export const erpObjectConversionRequestOptionsEntityDefinition: EntitiyDefinition<ErpObjectConversionRequestOptions> =
  {
    local: {},
    remote: {
      queryName: '',
      fragmentName: 'ErpObjectConversionRequestOptions',
      withPaginationWrapper: false,
    },
    fieldDefinitions: fields,
  };
